import _defineProperty from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty";
import _Object$assign from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/core-js/object/assign";
import _objectSpread from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/objectSpread";
import "core-js/modules/es6.function.name";

var _types$UPDATE_RESULT_;

import * as types from "@/store/constants/types";
import { isObject } from "@/utils/deepCloneUtil";
export default (_types$UPDATE_RESULT_ = {}, _defineProperty(_types$UPDATE_RESULT_, types.UPDATE_RESULT_BY_NAME, function (state, payLoad) {
  var name = payLoad.name,
      result = payLoad.result;

  if (isObject(result)) {
    var old_result = _objectSpread({}, state[name]);

    state[name] = _Object$assign(old_result, result);
  } else {
    state[name] = result;
  }
}), _defineProperty(_types$UPDATE_RESULT_, types.RESET_RESULT_BY_NAME, function (state, payLoad) {
  if (payLoad && state[payLoad]) {
    state[payLoad] = null;
  }

  if (!state.maskShow) {
    state.maskShow = true;
  }
}), _defineProperty(_types$UPDATE_RESULT_, types.UPDATE_FUNCTION_LIST, function (state, payLoad) {
  var name = payLoad.name,
      result = payLoad.result;
  state[name] = result;
}), _types$UPDATE_RESULT_);